import { useOptionalSession } from "@/shared/auth/session";
import { DEFAULT_ORG_TIMEZONE } from "@/shared/constants/limits";

/** The organisation's IANA timezone from /me; the fallback only applies before sign-in (ADR-0003). */
export function useOrgTimezone(): string {
  const session = useOptionalSession();
  return session?.tenant.timezone || DEFAULT_ORG_TIMEZONE;
}
